import { createContext, useContext } from 'react';
import { ClientIdentityProjection } from '@/utils/nameMatching';

export interface FirmClientIdentityIndexContextType {
    index: ClientIdentityProjection[];
    isReady: boolean;
    invalidateIdentityIndex: () => void;
}

export const FirmClientIdentityIndexContext =
    createContext<FirmClientIdentityIndexContextType | undefined>(undefined);

export function useFirmClientIdentityIndex() {
    const context = useContext(FirmClientIdentityIndexContext);
    if (context === undefined) {
        throw new Error(
            'useFirmClientIdentityIndex must be used within a FirmClientIdentityIndexProvider',
        );
    }
    return context;
}
